// Allows us to pass in multiple refs by handling both functional refs and
// mutable ref objects.
//
// Example:
// const mutableRef = React.useRef();
// const refFn = ref => (this.node = ref);
//
// <div ref={mergeRefs(refFn, mutableRef)} />

const mergeRefs = (...refs) => (ref) => {
  refs.forEach((refHandler) => {
    if (typeof refHandler === 'function') {
      refHandler(ref);
    } else if (typeof refHandler === 'object' && refHandler != null) {
      refHandler.current = ref;
    }
  });
};

export default mergeRefs;
